import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  inject,
  input,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { EditorOptions } from 'tinymce';
import { QarepaBaseSubsDirective } from '@qarepa/common';

@Component({
  selector: 'qaroni-tinymce-textarea',
  templateUrl: './tinymce-textarea.component.html',
  styleUrls: ['./tinymce-textarea.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TinymceTextareaComponent
  extends QarepaBaseSubsDirective
  implements OnInit
{
  readonly fc = input<FormControl | null>(null);

  private _cdr = inject(ChangeDetectorRef);

  public tinyInit: Partial<EditorOptions> = {
    base_url: '/tinymce',
    suffix: '.min',
    height: 225,
    branding: false,
    menubar: false,
    plugins: [
      'advlist',
      'autolink',
      'lists',
      'link',
      'charmap',
      'preview',
      'anchor',
      'searchreplace',
      'visualblocks',
      'code',
      'fullscreen',
      'insertdatetime',
      'media',
      'table',
      'wordcount',
    ],
    toolbar: `undo redo | formatselect | bold italic backcolor |
    alignleft aligncenter alignright alignjustify |
    bullist numlist outdent indent | link | insertmediaimage | removeformat | help`,
    license_key: 'gpl',
  };

  ngOnInit(): void {
    this.subs.add(
      this.fc()
        ?.valueChanges.pipe(debounceTime(500))
        .subscribe(this.getTinyValueChanges)
    );
  }

  private getTinyValueChanges = (valueChanges): void => {
    if (valueChanges) {
      this._cdr.markForCheck();
    }
  };
}
